/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Cost_ColumnInputs */

const en_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost / req`)
};

const zh_hans1_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次成本`)
};

const pt_br2_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custo / req`)
};

const es_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo / sol.`)
};

const fr_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coût / req`)
};

const de_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten / Anfr.`)
};

const ru_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена / запрос`)
};

const it_endpoint_cost_column = /** @type {(inputs: Endpoint_Cost_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo / richiesta`)
};

/**
* | output |
* | --- |
* | "Cost / req" |
*
* @param {Endpoint_Cost_ColumnInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_column = /** @type {((inputs?: Endpoint_Cost_ColumnInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_ColumnInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_column(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_column(inputs)
	if (locale === "es") return es_endpoint_cost_column(inputs)
	if (locale === "fr") return fr_endpoint_cost_column(inputs)
	if (locale === "de") return de_endpoint_cost_column(inputs)
	if (locale === "ru") return ru_endpoint_cost_column(inputs)
	if (locale === "it") return it_endpoint_cost_column(inputs)
	return en_endpoint_cost_column(inputs)
});